import { render, staticRenderFns } from "./sidebarGroup.vue?vue&type=template&id=b68c8808&"
import script from "./sidebarGroup.vue?vue&type=script&lang=ts&"
export * from "./sidebarGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports